/**
 * Created by Languagenut on 25/01/2019.
 */



import React  from 'react';
import './payment.css';
import {Row , Col } from "react-bootstrap";
import LicenceService from '../../services/licence-service.js';
import LicenceStore   from '../../store/licence-store.js';
import Constants from '../../constants.js';

const braintree = window.braintree;
const paypal = window.paypal;

export default class PaypalPayment extends React.Component {

    constructor(props) {
        super();
        this.props = props;
        this.state = {}
    }

    setupBraintree(){
        braintree.client.create({
            authorization: 'sandbox_g42y39zw_348pk9cgf3bgyw2b'
        }, function (clientErr, clientInstance) {


            if (clientErr) {
                console.error('Error creating client:', clientErr);
                return;
            }


            braintree.paypalCheckout.create({
                client: clientInstance
            }, function (paypalCheckoutErr, paypalCheckoutInstance) {


                if (paypalCheckoutErr) {
                    console.error('Error creating PayPal Checkout:', paypalCheckoutErr);
                    return;
                }

                // Set up PayPal with the checkout.js library
                paypal.Button.render({
                    env: 'production', // or 'sandbox'

                    payment: function () {
                        return paypalCheckoutInstance.createPayment({
                            // Your PayPal options here. For available options, see
                            // http://braintree.github.io/braintree-web/current/PayPalCheckout.html#createPayment
                        });
                    },

                    onAuthorize: function (data, actions) {
                        return paypalCheckoutInstance.tokenizePayment(data, function (err, payload) {
                            // Submit `payload.nonce` to your server.
                        });
                    },

                    onCancel: function (data) {
                        console.log('checkout.js payment cancelled', JSON.stringify(data, 0, 2));
                    },

                    onError: function (err) {
                        console.error('checkout.js error', err);
                    }
                }, '#paypal-button').then(function () {
                    // The PayPal button will be rendered in an html element with the id
                    // `paypal-button`. This function will be called when the PayPal button
                    // is set up and ready to be used.
                });

            });

        });
    }

    componentWillMount(){
        LicenceStore.once(Constants.GOT_BRAINTREE_CODE , () =>{
            this.setupBraintree();
        });
    }

    componentDidMount(){
        LicenceService.getCode();
    }


    render(){
        return <div>
            <br/>
            <div class='card-wrapper'></div>
            <br/>
            <form >
                <Row>
                    <Col md={12}><div id="paypal-button"></div></Col>
                </Row>
            </form>
            <br/>
        </div>
    }
}